import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Globe, Lock, Info } from 'lucide-react';

const VisibilityOption = ({ value, current, onChange, icon: Icon, title, text }) => (
  <button
    type="button"
    onClick={() => onChange(value)}
    data-testid={`visibility-${value}`}
    className={`flex-1 text-left rounded-xl border p-3 transition-colors ${
      current === value ? 'border-violet-600 bg-violet-50 ring-1 ring-violet-600' : 'border-slate-200 bg-white hover:border-violet-300'
    }`}
  >
    <div className="flex items-center gap-2 text-sm font-semibold text-slate-900">
      <Icon className="w-4 h-4 text-violet-600" /> {title}
    </div>
    <p className="text-xs text-slate-500 mt-1">{text}</p>
  </button>
);

const GroupOptions = ({ tiers, groupSize, onGroupSize, visibility, onVisibility }) => (
  <div className="space-y-4" data-testid="group-options">
    <div className="space-y-2">
      <Label>Number of students (places)</Label>
      <Select value={String(groupSize)} onValueChange={(v) => onGroupSize(Number(v))}>
        <SelectTrigger data-testid="group-size-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {tiers.map((t) => (
            <SelectItem key={t.students} value={String(t.students)} data-testid={`group-size-option-${t.students}`}>
              {t.students === 1 ? 'Just me (1 student)' : `${t.students} students`} · ₹{t.rate_per_hour}/hr
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>

    {groupSize > 1 && (
      <div className="space-y-2">
        <Label>Who can join?</Label>
        <div className="flex flex-col sm:flex-row gap-2">
          <VisibilityOption value="invite_only" current={visibility} onChange={onVisibility} icon={Lock}
            title="Invite only" text="Hidden. Share your invite link with friends." />
          <VisibilityOption value="discoverable" current={visibility} onChange={onVisibility} icon={Globe}
            title="Discoverable" text="Listed in Discover Sessions for all students." />
        </div>
        <div className="flex items-start gap-2 bg-sky-50 border border-sky-200 rounded-lg p-3" data-testid="group-payment-note">
          <Info className="w-4 h-4 text-sky-600 mt-0.5 shrink-0" />
          <p className="text-xs text-sky-800">
            You pay for all {groupSize} places upfront. Students you accept join free on the platform — no split
            payments. The price and number of places are locked once you pay; to change them, rebook.
          </p>
        </div>
      </div>
    )}
  </div>
);

export default GroupOptions;
